const homeSlider = [
  {
    id:0,
    slideClassName: "image0",
  },
  {
    id: 1,
    slideClassName: "image1",
  },
  {
    id: 2,
    slideClassName: "image2",
  },
  {
    id: 3,
    slideClassName: "image3",
  },
];
export default homeSlider;
